import { useState } from "react";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { UserRound } from "lucide-react";
import { ProfileCompletionStatus, IncompleteField } from "@/lib/auth/utils/profile";
import { ProfileCompletionPopup } from "./ProfileCompletionPopup";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

interface ProfileCompletionIndicatorProps {
  status: ProfileCompletionStatus;
}

const fieldLabels: Record<IncompleteField, string> = {
  personal: "Personal Information",
  school: "School Information",
  position: "Position Information"
};

export function ProfileCompletionIndicator({ status }: ProfileCompletionIndicatorProps) {
  const [showPopup, setShowPopup] = useState(false);

  if (status.isComplete) {
    return null;
  }

  return (
    <>
      <HoverCard>
        <HoverCardTrigger asChild>
          <Button 
            variant="outline" 
            size="sm" 
            className="gap-2 border-[#004161]/10 hover:border-[#004161]/20"
            onClick={() => setShowPopup(true)}
          >
            <UserRound className="h-4 w-4 text-[#004161]" />
            <span className="text-[#004161] font-serif">Complete Profile</span>
            <Progress 
              value={status.percentComplete} 
              className="w-12 h-2 bg-[#004161]/10" 
              indicatorClassName="bg-[#004161]"
            />
          </Button>
        </HoverCardTrigger>
        <HoverCardContent className="w-80">
          <div className="space-y-2">
            <h4 className="font-serif text-[#004161]">Profile Completion</h4>
            <p className="text-sm text-[#004161]/70">
              Please complete the following information:
            </p>
            <ul className="space-y-1">
              {status.incompleteFields.map((field) => (
                <li key={field} className="text-sm text-[#004161]/70 flex items-center gap-2">
                  • {fieldLabels[field]}
                </li>
              ))}
            </ul>
          </div>
        </HoverCardContent>
      </HoverCard>

      <ProfileCompletionPopup 
        open={showPopup}
        onOpenChange={setShowPopup}
        incompleteFields={status.incompleteFields}
      />
    </>
  );
} 